import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const Cross = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99949 9.45375L1.45426 16L0 14.5447L6.54522 7.99949L0 1.45426L1.45426 0L7.99949 6.54522L14.5447 0L16 1.45426L9.45375 7.99949L15.999 14.5447L14.5437 16L7.99949 9.45375Z"
      fill="#ffffff"
    />
  </svg>
))

export default Cross
